import React from "react"
import { Confirm } from "../../../../../Common/Modal/Confirm"
import { useAsyncCommand } from "../../../../../../Hooks/useAsyncCommand"
import {
    enqueuable,
    JobStatus,
    jobStatusToName,
    notEnqueuable
} from "../../../../../../Models/API/JobModel"
import { IconCheck } from "dash-styled"
import { ReactComponent as IconClose } from "icons/lib/close-icon.svg"
import { APIJobsPerStatusModel } from "../../../../../../Models/API/APIJobsPerStatusModel"
import { LoaderModal } from "../../../../../Common/Modal/LoaderModal"

interface EnqueueModalProps {
    total: number
    jobsByStatus?: APIJobsPerStatusModel
    onYes: () => Promise<void>
    onNo: () => void
    isLabelByCollaborator: boolean
}

export function EnqueueModal({
    total,
    onNo,
    onYes,
    jobsByStatus,
    isLabelByCollaborator
}: EnqueueModalProps) {
    const { perform, isProcessing } = useAsyncCommand(onYes)

    if (!jobsByStatus) return <LoaderModal onClose={onNo} />

    const description =
        total > 1 ? (
            jobsByStatus &&
            notEnqueuable().find(
                item =>
                    item !== JobStatus.IN_CREATION &&
                    (jobsByStatus[item] ?? 0) > 0
            ) ? (
                <>
                    <p className="text-rhino-800 mb-3">Data points affected:</p>
                    {enqueuable().map(item => {
                        if (item === JobStatus.IN_CREATION) {
                            return null
                        }
                        const entry = jobsByStatus[item]
                        return !entry ? null : (
                            <div
                                className="flex items-center mb-0.5"
                                key={item}
                            >
                                <IconCheck
                                    className="text-moss-600 mt-px mr-1"
                                    size="lg"
                                />
                                <span className="text-rhino-800">
                                    {entry}{" "}
                                    {jobStatusToName(
                                        item,
                                        isLabelByCollaborator
                                    )}
                                </span>
                            </div>
                        )
                    })}
                    {notEnqueuable().map(item => {
                        if (item === JobStatus.IN_CREATION) {
                            return null
                        }
                        const entry = jobsByStatus[item]
                        return !entry ? null : (
                            <div
                                className="flex items-center mb-0.5"
                                key={item}
                            >
                                <IconClose className="text-blood-700 mt-px mr-1 p-0.5 w-5 h-5" />
                                <span className="text-rhino-800">
                                    {entry}{" "}
                                    {jobStatusToName(
                                        item,
                                        isLabelByCollaborator
                                    )}
                                </span>
                            </div>
                        )
                    })}
                </>
            ) : null
        ) : null

    return (
        <Confirm
            title={`Queue ${total} data point${
                total > 1 ? "s" : ""
            } for processing?`}
            description={description}
            yesLabel="Queue"
            isProcessing={isProcessing}
            onClickYes={perform}
            onClose={onNo}
        />
    )
}
